/**
 * @module support/state-object-hash-utilities
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

export class ObjectError {
  /**
   * Stores the object value for obj
   */
  public obj: object;

  /**
   * Stores the string value for path
   */
  public path: string;

  /**
   * Stores the string value for message
   */
  public message: string;

  constructor() {
    this.obj = {};
    this.path = '';
    this.message = '';
  }
}
